import { useQuery } from "react-query";
import { axiosClient } from "../services/axiosInstance";

const useGetSurveyType = () => {
  const data = useQuery(["getSurveyType"], () =>
    axiosClient.post(`Setting/GepSettingList?groupSettingId=5`)
  );
  return data;
};
export default useGetSurveyType;
